import { BASE_URL } from "../general/variables";
import { initDefaultSelect2 } from "../general/functions";
import intlTelInput from "intl-tel-input";

var ajaxToken = $('meta[name="icanToken"]').attr("content");
const templatePackages = `
  <div class="custom-control custom-checkbox px-0 mb-4">
      <input type="checkbox" class="custom-control-input expo-checkbox" name="package[]" value="[PACKAGE_ID]" data-price="[PACKAGE_PRICE]" id="[PACKAGE_INPUT_ID]">
      <label class="expo-card" for="[PACKAGE_INPUT_FOR]">
          <div class="d-flex justify-content-between align-items-start">
              <div>
                  <h5 class="fw-bolder text-dark mb-1 packageName">[PACKAGE_NAME]</h5>
                  <small class="packageDate text-primary-ican fw-bold">[PACKAGE_DATE]</small>
              </div>

              <div class="text-primary fw-bolder fs-3 packagePrice">USD [PACKAGE_PRICE]</div>
          </div>
      </label>
  </div>
`;

const templatePckgSelected = `
  <div class="col-md-12 form-group mb-3 d-flex flex-column">
      <label class="fw-bolder col-form-label mb-0 fs-7 text-dark">[EXPO_NAME]</label>
      <span class="text-primary-ican fw-bold fs-8">[EXPO_DATE]</span>
  </div>
  <div class="col-md-12 [EXPO_CLASS]">
    <div class="separator separator-solid separator-border-3 my-1"></div>
  </div>
`;

const loaderStep = `
  <div class="e-backdrop">
    <div class="e-loadholder">
      <div class="m-loader">
        <span class="e-text fw-bolder">Loading...</span>
      </div>
    </div>
    <div id="particleCanvas-Blue"></div>
    <div id="particleCanvas-White"></div>
  </div>
`;

const loaderCircle = `
  <div class="d-flex flex-center h-100">
    <svg class="spinnerCircle" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="pathCircle" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
    </svg>
  </div>
`;

const elemPhone = document.querySelector(".pic-numbers");
const intlPhone = elemPhone
  ? intlTelInput(elemPhone, {
      initialCountry: "id",
      countrySearch: true,
      loadUtils: () => import("intl-tel-input/utils"),
    })
  : null;

const initSelect2Setup = () => {
  initDefaultSelect2(
    true,
    {
      endpoint: `${BASE_URL}university-api/get-uni`,
      data: {
        token: ajaxToken,
        content: "expo",
      },
    },
    'select[name="university"]',
    undefined,
    $('select[name="university"]').data("placeholder"),
    false,
    false,
    true,
  );

  initDefaultSelect2(
    true,
    {
      endpoint: `${BASE_URL}university-api/get-currency-billing`,
      data: {
        token: ajaxToken,
        content: "expo",
      },
    },
    'select[name="invoice_billing"]',
    undefined,
    $('select[name="invoice_billing"]').data("placeholder"),
    false,
    false,
    true,
  );
};

export {
  ajaxToken,
  templatePackages,
  templatePckgSelected,
  loaderStep,
  loaderCircle,
  intlPhone,
  initSelect2Setup,
};
